import LoadingSuspense from "./LoadingSuspense";

export default LoadingSuspense;
